// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import MasterService from '@services/masters'

export const getCountry = createAsyncThunk('country/getCountry', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllCountry(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getCountryById = createAsyncThunk('country/getCountryById', async (id) => {
  const response = await MasterService.getCountryById(id)
  return response
})

export const addCountry = createAsyncThunk('country/addCountry', async (country, { rejectWithValue }) => {
  try {
    const response = await MasterService.addCountry(country)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateCountry = createAsyncThunk('country/updateCountry', async (country, { rejectWithValue }) => {
  try {
    const response = await MasterService.updateCountry(country)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteCountry = createAsyncThunk('country/deleteCountry', async (id, { dispatch, getState }) => {
  await MasterService.deleteCountry(id)
  await dispatch(getCountry(getState()?.countries.params))
  return id
})

export const countrySlice = createSlice({
  name: 'country',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualCountry: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountry.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getCountryById.fulfilled, (state, action) => {
        state.individualCountry = action.payload
        state.loading = false
      })
      .addCase(getCountryById.pending, (state, action) => {
        state.individualCountry = action.payload
        state.loading = true
      })
      .addCase(getCountryById.rejected, (state, action) => {
        state.individualCountry = action.payload
        state.loading = false
      })
  }
})

export default countrySlice.reducer
